import {PaperClipOutlined} from '@ant-design/icons';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';

import {getFileNameFromSource, getFromSource} from '@/utils/getImages';

const DownloadElement = ({value, customName, center, isFull = false}) => {
  const fileName = useMemo(() => {
    try {
      return getFileNameFromSource(value);
    } catch (e) {
      return value?.split('/')?.pop();
    }
  }, [value]);

  return <div
    className={classNames('truncate flex items-center', {'justify-center': center}, {'justify-between': !center}, {'w-full': isFull})}>
    <a href={getFromSource(value)} target="_blank" className="flex items-center truncate" rel="noreferrer">
      <PaperClipOutlined/>
      {(fileName || customName) && <div className="mr-4 ml-1 truncate">{customName || fileName}</div>}
    </a>
  </div>;

};

const DownloadFile = ({value, defaultValue, renderExtra, ...rest}) => {
  const isList = useMemo(() => Array.isArray(value), [value]);

  if (!value || isEmpty(value))
    return defaultValue || null;

  if (!isList || typeof value === 'string')
    return <DownloadElement {...rest} value={value}/>;

  return value.map((e, i) => {
    return <div className="mb-2 flex" key={i}>
      <DownloadElement {...rest} value={e}/>
      {renderExtra && renderExtra(e)}
    </div>;
  });
};

DownloadElement.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  defaultValue: PropTypes.any,
  isFull: PropTypes.bool,
  center: PropTypes.bool,
  customName: PropTypes.string,
  buttonText: PropTypes.string,
};

DownloadFile.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  center: PropTypes.bool,
  renderExtra: PropTypes.func
};

DownloadFile.defaultProps = {
  defaultValue: '-'
};

export default memo(DownloadFile);
